import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CONTACT, HREF } from '@core';
import { FooterNavLinkComponent } from './footer-nav-link/footer-nav-link.component';
import { AccessibleClickDirective } from '../directives/accessible-click.directive';

@Component({
  selector: 'lib-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, FooterNavLinkComponent, AccessibleClickDirective],
})
export class FooterComponent {
  readonly contact = CONTACT;
  clickLogo = output();

  readonly shopsLinks = [
    { title: 'Brand directory', linkLabel: 'See all brands', path: `/${HREF.BRANDS_DIRECTORY}` },
    { title: 'Find answers', linkLabel: 'Go to FAQs', path: `/${HREF.INFO}/${HREF.FAQ}` },
    {
      title: 'Contact us',
      content: `To speak with a specialist from Rymax customer service, call <a href="tel:${CONTACT.REQUEST_RETURN_PHONE}">${CONTACT.REQUEST_RETURN_PHONE}</a> from 9:00 a.m. to 7:00 p.m. ET, Monday to Friday, excluding holidays.`,
    },
  ];

  readonly customerCareLinks = [
    {
      title: 'Shipping and delivery',
      linkLabel: 'See all',
      ariaLabel: 'See all shipping and delivery information',
      path: `/${HREF.INFO}/${HREF.SHIPPING_AND_DELIVERY}`,
    },
    {
      title: 'Returns and refunds',
      linkLabel: 'See all',
      ariaLabel: 'See all returns and refunds information',
      path: `/${HREF.INFO}/${HREF.RETURNS_AND_REFUNDS}`,
    },
    {
      title: 'Store and product policy',
      linkLabel: 'See terms & conditions',
      ariaLabel: 'See terms & conditions',
      path: `/${HREF.INFO}/${HREF.TERMS_AND_CONDITIONS}`,
    },
    {
      title: 'Privacy policy',
      linkLabel: 'See privacy policy',
      ariaLabel: 'See privacy policy',
      path: `/${HREF.INFO}/${HREF.PRIVACY_POLICY}`,
    },
  ];
}
